/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'

import Error from '@/components/error'
import Alipay from '@/components/alipay'

import Index from '@/components/Index'
import Program from '@/components/program'
import Practical from '@/components/practical'
import Employment from '@/components/employment'
import Continue from '@/components/continue'
import Vrpractice from '@/components/Vrpractice'

import Course from '@/components/course'
import Test from '@/components/test'
import Personal from '@/components/personal/index'
import Student from '@/components/personal/student'
import Tearcher from '@/components/personal/tearcher'
import Detail from '@/components/personal/detail'
import SelectCourse from '@/components/personal/selectCourse'
import Tearchers from '@/components/personal/tearchers'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '*',
			component: Error
		},
		{
			path: '/',
			name: 'Index',
			component: Index
		},
		{
			path: '/program',
			name: 'program',
			component: Program
		},
		{
			path: '/practical',
			name: 'practical',
			component: Practical
		},
		{
			path: '/employment',
			name: 'employment',
			component: Employment
		},
		{
			path: '/continue',
			name: 'continue',
			component: Continue
		},
		{
			path: '/course/:id',
			name: 'course',
			component: Course
		},
		{
			path: '/vrpractice',
			name: 'vrpractice',
			component: Vrpractice
		},
		{
			path: '/personal',
			name: 'personal',
			component: Personal,
			children:[
				{
					path: 'student',
					name: 'student',
					component: Student
				},{
					path: 'tearcher',
					name: 'tearcher',
					component: Tearcher
				},{
					path: 'detail/:id',
					name: 'detail',
					component: Detail
				},{
					path: 'selectCourse',
					name: 'selectCourse',
					component: SelectCourse
				},{
                    path: 'tearchers',
                    name: 'tearchers',
                    component: Tearchers
                }
			]
		},{
			path: '/test/:id',
			name: 'test',
			component: Test
		},{
			path: '/alipay',
			name: 'alipay',
			component: Alipay
		}
	]
})
/* eslint-disable */


// WEBPACK FOOTER //
// ./src/router/index.js